import React from "react";
import "./styles.scss";
import Header from "../../components/header";

const HowItWorks = () => {
  return (
    <div>
      <Header />
    </div>
  );
};

export default HowItWorks;
